import { LOGO_SRC } from "@/constants/site";

export default function Loader() {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-brand-cream" data-testid="page-loader">
      <div className="relative">
        <img src={LOGO_SRC} alt="AM Group of Education" className="h-24 w-auto object-contain animate-float-slow" />
      </div>
      <div className="mt-6 text-center">
        <div className="display-serif text-lg font-bold text-brand-dark">AM Group of Education</div>
        <div className="text-xs tracking-[0.25em] uppercase text-brand-light mt-1">Learn Today, Lead Tomorrow</div>
      </div>
      <div className="loader-cap mt-6" />
    </div>
  );
}
